<aa-popin-v3 [isShown]="isShown"
  [onClose]="onClosePopin"
  [width]="52"
  [backPic]="'forms'"
  [hasCancelButton]=true>
  <span class="title">{{ 'ITSM.CREATESERVICEREQUEST.POPIN_TITLE' | translate }}</span>
  <div class="popin-content-body">
    <aa-wizard2 #wizard
      [height]="70"
      (selectedStep)="onSelectedStep($event)">
      <aa-step [disabled]="false"
        title="{{ 'ITSM.CREATESERVICEREQUEST.STEPS.STEP1.TAB' | translate }}">
        <ng-template aaStepContent>
          <aa-create-service-step1></aa-create-service-step1>
        </ng-template>
      </aa-step>
      <aa-step [disabled]="true"
        title="{{ 'ITSM.CREATESERVICEREQUEST.STEPS.STEP2.TAB' | translate }}">
        <ng-template aaStepContent>
          <aa-create-service-step2></aa-create-service-step2>
        </ng-template>
      </aa-step>
      <aa-step [disabled]="true"
        title="{{ 'ITSM.CREATESERVICEREQUEST.STEPS.STEP3.TAB' | translate }}">
        <ng-template aaStepContent>
          <aa-create-service-step3></aa-create-service-step3>
        </ng-template>
      </aa-step>
      <aa-step [disabled]="true"
        title="{{ 'ITSM.CREATESERVICEREQUEST.STEPS.STEP4.TAB' | translate }}">
        <ng-template aaStepContent>
          <aa-create-service-step4></aa-create-service-step4>
        </ng-template>
      </aa-step>
      <aa-step [disabled]="true"
        title="{{ 'ITSM.CREATESERVICEREQUEST.STEPS.STEP5.TAB' | translate }}">
        <ng-template aaStepContent>
          <aa-create-service-summary (close)="onClosePopin()"></aa-create-service-summary>
        </ng-template>
      </aa-step>
    </aa-wizard2>
  </div>
  <div class="popin-content-footer">
    @if (!lastStep) {
      <aa-btn-action-primary
        [btnText]="'BUTTON.NEXTSTEP' | translate"
        [cta]="onNextStep">
      </aa-btn-action-primary>
    }
    @if (lastStep) {
      <aa-btn-action-primary
        [btnText]="'BUTTON.CREATE' | translate"
        [cta]="onCreate">
      </aa-btn-action-primary>
    }
  </div>
</aa-popin-v3>
